<template>
  <v-tabs
    v-model="localTabs"
    optional
    centered
    height="32px"
    dense
    density="compact"
    hide-slider
    class="custom_tabs_root"
    active-class="custom_tabs_root-active"
  >
    <v-tab v-for="(item, index) in tabItems" :key="index" :ripple="false">
      {{ item.label }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: 'CustomTabs',
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: () => -1,
    },
    tabItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localTabs: this.value,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.localTabs = newValue;
      },
    },
    localTabs(newVal, oldVal) {
      if (newVal === undefined) {
        this.$nextTick(() => {
          this.localTabs = oldVal;
        });
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      this.$emit('input', newVal);
      this.$emit('onChange', newVal);
    },
  },
};
</script>

<style lang="scss">
.custom_tabs {
  &_root {
    width: 120px;

    .v-slide-group__content.v-tabs-bar__content {
      border-radius: 5px;
      background-color: #eee;
      padding: 2px 0;
    }
    .v-tab {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.54;
      letter-spacing: normal;
      text-align: left;
      min-width: 57px;
      padding: 0 10px;
    }
    &-active {
      border-radius: 5px;
      background-color: #fff;
      color: #0075c2;
    }
  }
}
</style>
